import { render, staticRenderFns } from "./MyTableHead.vue?vue&type=template&id=321fa2f9"
import script from "./MyTableHead.vue?vue&type=script&lang=js"
export * from "./MyTableHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports